import React from "react";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Box from '@mui/material/Box';
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { ClickActionEvent } from '../../util/analytics'


const sxRoot = { width: '80%', maxWidth: 800, pl: '10%' };


const socialContactClickedEvent = (contactName) => {
  ClickActionEvent("Contact "+contactName, 'About me section', "About me social contact clicked")
}

export default function Info() {
  var date1 = new Date("2/20/2018");
  var current = new Date();
  var date2 = new Date(
    current.getFullYear() +
      "/" +
      (current.getMonth() + 1) +
      "/" +
      current.getDate()
  );
  var diffDays = parseInt((date2 - date1) / (1000 * 60 * 60 * 24), 10);
  var diffYears = ((diffDays / 30 + 1) / 12).toFixed(1);
  console.log('diffYears', diffYears)

  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  React.useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  return (
    <Box sx={sxRoot}>
      <Typography variant="h3" gutterBottom>
        About Me <img loading="lazy" src="javedinfinte-logo-128.png" width="20%" height="auto" alt="javedinfinite logo" />
      </Typography>

      <Typography variant="body1" style={{ fontSize: "20px" }} gutterBottom>
        Hi I am <span style={{ color: "#1fd7a3" }}>Javed Akhtar</span>, a
        writer who writes code for computers as a Software Engineer, YouTuber,
        Bloggger, living in Siliguri, India. I am a Computer Science Engineer,
        currently working with awesome developers and I have 7+ years
        of experience. You can DM me on any of the social network or email📧 me
        at <span style={{ color: "#1fd7a3" }}>javedaktar73@gmail.com. </span>
        I love to work with geeks who are very excited on developing something
        with new tech stacks, lets meet and discuss something interesting <br />
        <span style={{ color: "#1fd7a3" }}>
          Chai☕ pe charcha karenge 😄...
        </span>
      </Typography>
      <Typography variant="h1" align="center" gutterBottom>
      <Link
          href="https://www.linkedin.com/in/javed-akhtar-07370613b/"
          target="_blank"
          rel="noreferrer noopener"
          onClick={() => socialContactClickedEvent('linkedin')}
        >
          <LinkedInIcon style={{ color: '#0077B5', fontSize: windowWidth >= 650 ? '50%' : '23%' }} />
        </Link>{" "}

        <Link
          href="https://www.youtube.com/@javedinfinite"
          target="_blank"
          rel="noreferrer noopener"
          onClick={() => socialContactClickedEvent('youtube')}
        >
          <YouTubeIcon style={{ color: '#cd201f', fontSize: windowWidth >= 650 ? '50%' : '23%' }} />
        </Link>{" "}
        <Link
          href="https://medium.com/@javedinfinite"
          target="_blank"
          rel="noreferrer noopener"
          onClick={() => socialContactClickedEvent('medium')}
        >
          <img loading="lazy" src="https://img.icons8.com/ios-glyphs/30/000000/medium-monogram.png" alt="medium" style={{ height: windowWidth >= 650 ? '50px' : '23px' }} />
        </Link>{" "}
        <Link href="https://www.instagram.com/javedinfinite/" target="_blank" rel="noreferrer noopener" onClick={() => socialContactClickedEvent('instagram')}>
          <InstagramIcon style={{ color: '#e4455f', fontSize: windowWidth >= 650 ? '50%' : '23%' }} />
        </Link>{" "}
        <Link
          href="https://www.facebook.com/people/Javed-Akhtar/100004054069579/"
          target="_blank"
          rel="noreferrer noopener"
          onClick={() => socialContactClickedEvent('facebook')}
        >
          <FacebookIcon style={{ color: '#3b5999', fontSize: windowWidth >= 650 ? '50%' : '23%' }} />
        </Link>{" "}

        <Link href="https://twitter.com/javedinfinite" target="_blank" rel="noreferrer noopener" onClick={() => socialContactClickedEvent('twitter')}>
          <TwitterIcon style={{ color: '#55acee', fontSize: windowWidth >= 650 ? '50%' : '23%' }} />
        </Link>{" "}

      </Typography>
    </Box>
  );
}
